import Chip from '@mui/material/Chip';
import ConfirmationNumberIcon from '@mui/icons-material/ConfirmationNumber';
const CustomChip =({label,icon, color, bg, transform, variant}:{label: any, icon: any, color:any, bg:any, transform:any, variant: any})=>{
    return <>
    
<Chip  size="small" variant={variant} className='timeline-undefined' color="primary" sx={{ width:"auto", height:"auto", borderRadius:"5px", backgroundColor:bg, color:color, display:"inline-flex",alignItems:"center", padding:"3px", position:"relative", maxWidth:"180px" ,fontSize:"12px"}} label={`${label}`}  icon={icon} />
</>
}
export default CustomChip